"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _RadioGroup = _interopRequireDefault(require("@mui/material/RadioGroup"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _index = require("@jordibosch20/software_tools_package/dist/index");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Base64CentralWrapper(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    dataFromInput = _useState2[0],
    setDataFromChild = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSelect = _useState4[0],
    setActiveSelect = _useState4[1];
  var _useState5 = (0, _react.useState)("encode"),
    _useState6 = _slicedToArray(_useState5, 2),
    encodingRadio = _useState6[0],
    setEncodingRadio = _useState6[1];
  var _useState7 = (0, _react.useState)("utf8"),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedEncodingValue = _useState8[0],
    setSelectedEncodingValue = _useState8[1];
  var _useState9 = (0, _react.useState)("no"),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedNewLine = _useState10[0],
    setSelectedNewLine = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    fileUploaded = _useState12[0],
    setFileUploaded = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    displayForSomeTime = _useState14[0],
    setDisplayForSomeTime = _useState14[1];
  var handleDataFromInput = function handleDataFromInput(dataFromChild) {
    setDataFromChild(dataFromChild);
    setFileUploaded(null);
  };
  var handleChange = function handleChange(event) {
    setSelectedEncodingValue(event.target.value);
  };
  var handleChangeNewLine = function handleChangeNewLine(event) {
    setSelectedNewLine(event.target.value);
  };
  var handleChangeRadioButton = function handleChangeRadioButton(event) {
    setEncodingRadio(event.target.value);
  };
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    anchorEl1 = _useState16[0],
    setAnchorEl1 = _useState16[1];
  var handleClick1 = function handleClick1(event) {
    setAnchorEl1(event.currentTarget);
  };
  var handleClose1 = function handleClose1() {
    setAnchorEl1(null);
  };
  var open1 = Boolean(anchorEl1);
  var id1 = open1 ? "simple-popover1" : undefined;
  var handleFileChange = function handleFileChange(event) {
    var file = event.target.files[0];
    setFileUploaded(file);
    setDisplayForSomeTime(true);
    setTimeout(function () {
      return setDisplayForSomeTime(false);
    }, 1500);
  };
  var handleActiveSelect = function handleActiveSelect(value) {
    setActiveSelect(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.CommonComponent, {
      sendDataToParent: handleActiveSelect,
      title: props.title,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormControl, {
          ref: function ref(_ref) {
            console.log("ref", _ref);
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RadioGroup["default"], {
            row: true,
            "aria-labelledby": "demo-row-radio-buttons-group-label",
            name: "row-radio-buttons-group",
            onChange: handleChangeRadioButton,
            value: encodingRadio,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel["default"], {
              value: "encode",
              sx: {
                "& .MuiTypography-root": {
                  fontSize: 12
                }
              },
              control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio["default"], {
                sx: {
                  "& .MuiSvgIcon-root": {
                    fontSize: 12
                  }
                }
              }),
              label: "Encode"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel["default"], {
              value: "decode",
              sx: {
                "& .MuiFormControlLabel-label": {
                  fontSize: 12
                }
              },
              control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio["default"], {
                sx: {
                  "& .MuiSvgIcon-root": {
                    fontSize: 12
                  }
                }
              }),
              label: "Decode"
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
          variant: "standard",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
            id: "label-1",
            variant: "contained",
            onMouseEnter: handleClick1,
            htmlFor: "encoding-select",
            children: ["Encoding:", " "]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select["default"], {
            labelId: "label-1",
            id: "encoding-select",
            value: selectedEncodingValue,
            onChange: handleChange,
            sx: {
              width: 200,
              // Smaller width
              fontSize: "0.875rem",
              // Smaller font size
              ".MuiSelect-select": {
                // Targeting the internal select element
                paddingTop: "3px",
                paddingBottom: "3px",
                fontSize: "12px"
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "utf8",
              children: "UTF-8"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "utf-16le",
              children: "UTF-16 LE"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "utf-16be",
              children: "UTF-16 BE"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "utf-32be",
              children: "UTF-32 LE"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "utf-32be",
              children: "UTF-32 BE"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "cesu8",
              children: "Cesu 8"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "usc2",
              children: "USC 2"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "windows1251",
              children: "Windows 1251"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "windows1252",
              children: "Windows 1252"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "windows1254",
              children: "Windows 1254"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-1",
              children: "ISO-8859-1"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-2",
              children: "ISO-8859-2"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-3",
              children: "ISO-8859-3"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-4",
              children: "ISO-8859-4"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-5",
              children: "ISO-8859-5"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-6",
              children: "ISO-8859-6"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-7",
              children: "ISO-8859-7"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-8",
              children: "ISO-8859-8"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-9",
              children: "ISO-8859-9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-10",
              children: "ISO-8859-10"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-11",
              children: "ISO-8859-11"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-12",
              children: "ISO-8859-12"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-13",
              children: "ISO-8859-13"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-14",
              children: "ISO-8859-14"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-15",
              children: "ISO-8859-15"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "iso-8859-16",
              children: "ISO-8859-16"
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
          variant: "standard",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
            id: "demo-simple-select-standard-label",
            variant: "contained",
            htmlFor: "encoding-newline",
            children: ["Encode each new line separatedly:", " "]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select["default"], {
            labelId: "demo-simple-select-standard-label",
            id: "demo-simple-select-standard",
            value: selectedNewLine,
            onChange: handleChangeNewLine,
            label: "Age",
            className: "select",
            sx: {
              width: 200,
              // Smaller width
              fontSize: "0.875rem",
              // Smaller font size
              ".MuiSelect-select": {
                // Targeting the internal select element
                paddingTop: "3px",
                paddingBottom: "3px",
                fontSize: "12px"
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "no",
              children: "No"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
              value: "yes",
              children: "Yes"
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
          htmlFor: "upload-button",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            accept: "/*" // Specify file types to accept, e.g., 'image/*', 'application/pdf', etc.
            ,
            id: "upload-button",
            type: "file",
            style: {
              display: "none"
            } // Hide the default input
            ,
            onChange: handleFileChange
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
            variant: "outlined",
            color: "primary",
            component: "span" // So that the InputLabel is styled like a button
            ,
            sx: {
              fontSize: "10px"
            },
            children: "Upload Custom File"
          }), fileUploaded && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [displayForSomeTime && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress["default"], {
              sx: {
                fontSize: 12,
                width: "20px !important",
                height: "20px !important",
                marginLeft: "10px !important"
              }
            }), !displayForSomeTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                "font-size": "12px",
                marginLeft: "10px !important"
              },
              children: "   File uploaded ✅"
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Popover, {
          sx: {
            color: "red"
          },
          id: id1,
          open: open1,
          anchorEl: anchorEl1,
          onClose: handleClose1,
          onMouseOut: handleClose1,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
            sx: {
              p: 0.4,
              fontSize: "12px"
            },
            children: "The type of encoding for your text you want to use. By default almost all systems use UTF-8."
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Input, {
        sendDataToParent: handleDataFromInput
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Output, {
        activeSelect: activeSelect,
        f: props.f,
        input: dataFromInput,
        encoding: selectedEncodingValue,
        newline: selectedNewLine,
        file: fileUploaded,
        encodingRadio: encodingRadio
      })]
    })
  });
}
var _default = exports["default"] = Base64CentralWrapper;